module.exports = __webpack_public_path__ + "img/juegos_btn.png.fce26717.webp";